/* ECLIPSE STUDIOS* — alle Animationen 1:1 (GSAP kommt aus theme.liquid) */
var ES2A = "//www.eclipse-studios.de/cdn/shop/t/14/assets/";

(function(){
  'use strict';

  /* Mobile-Modus: weniger Blaetter, kleinere Texturen, keine Deko-Layer (60fps-Ziel) */
  var IS_M = window.matchMedia('(max-width:768px)').matches;

  /* ============ KONFIG: Assets (Dateien in assets/ ablegen) ============ */
  var ASSET_DIR = ES2A;
  var COVER_FRONT = { f:'cover-front', alt:'YES. I AM A STYLIST, front cover' };
  var COVER_BACK  = { f:'cover-back',  alt:'YES. I AM A STYLIST, back cover' };
  // Flache, frontale Seiten-Scans (Hochformat 148:210) als Blatt-TEXTUREN.
  // KEINE vorgerenderten/gekippten Spreads — die Perspektive macht der CSS-3D-Code.
  // Blatt k: Vorderseite = Seite 2k-1, Rückseite = Seite 2k. Optional dwell pro Seite.
  var PAGES = [
    { f:'page-01', alt:'Page 1' },
    { f:'page-02', alt:'Page 2' },
    { f:'page-03', alt:'Page 3' },
    { f:'page-04', alt:'Page 4' },
    { f:'page-05', alt:'Page 5' },
    { f:'page-06', alt:'Page 6' },
    { f:'page-07', alt:'Page 7' },
    { f:'page-08', alt:'Page 8' },
    { f:'page-09', alt:'Page 9' },
    { f:'page-10', alt:'Page 10' },
    { f:'page-11', alt:'Page 11' },
    { f:'page-12', alt:'Page 12' },
    { f:'page-13', alt:'Page 13' }
  ];
  var PAGES_ALL = PAGES;
  if(IS_M){ PAGES = PAGES.slice(0, 7); }   /* mobil: 4 Blaetter/3 Turns statt 7/6 */
  var DWELL = 1.0;      // Standard-Lese-Pause pro Ansicht
  var OPEN_K = 1.0;     // Länge der Cover-Öffnung (1 = Standard)
  var EXT = ['jpg','webp','png'];

  /* ============ Bild-Helfer: Endungen durchprobieren, sonst Platzhalter ============ */
  function phSvg(name, w, h){
    var s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '">'
      + '<rect width="' + w + '" height="' + h + '" fill="#161616"/>'
      + '<circle cx="' + (w/2) + '" cy="' + (h*.42) + '" r="26" fill="none" stroke="#3a3a3a" stroke-width="1.5"/>'
      + '<circle cx="' + (w/2+8) + '" cy="' + (h*.42-5) + '" r="24" fill="#161616"/>'
      + '<text x="' + (w/2) + '" y="' + (h*.67) + '" fill="#777" font-family="monospace" font-size="8" text-anchor="middle">' + name + '.jpg/.webp/.png</text>'
      + '<text x="' + (w/2) + '" y="' + (h*.73) + '" fill="#555" font-family="monospace" font-size="6.5" text-anchor="middle">add to assets/</text>'
      + '</svg>';
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(s);
  }
  var IMG_Q = IS_M ? '?width=520' : '';   /* mobil: kleinere Blatt-Texturen vom CDN */
  function mkImg(base, alt, eager, w, h){
    var img = document.createElement('img');
    img.alt = alt || base;
    img.decoding = 'async';
    if(!eager) img.loading = 'lazy';
    img.setAttribute('data-i','0');
    img.onerror = function(){
      var i = +img.getAttribute('data-i') + 1;
      if(i < EXT.length){ img.setAttribute('data-i', i); img.src = ASSET_DIR + base + '.' + EXT[i] + IMG_Q; }
      else { img.onerror = null; img.src = phSvg(base, w || 148, h || 210); }
    };
    img.src = ASSET_DIR + base + '.' + EXT[0] + IMG_Q;
    return img;
  }

  /* ============ DOM bauen (läuft immer, auch im Statik-Modus) ============ */
  var book = document.getElementById('bkBook');
  var coverEl = document.getElementById('bkCover');
  var strip = document.getElementById('fbStrip');
  if(!book || !coverEl || !strip){ return; }   /* kein Hero auf dieser Seite (Collection/Produkt/Story) */
  var leafEls = [];
  var LEAVES = Math.ceil(PAGES.length / 2);
  var blocktopEl = document.querySelector('.bk-blocktop');
  function innerBoard(txt){
    var d = document.createElement('div'); d.className = 'fb-inner';
    d.innerHTML = '<svg viewBox="0 0 100 100" style="width:34px;height:34px" aria-hidden="true">'
      + '<defs><mask id="es2m' + (++innerBoard._i || (innerBoard._i = 1)) + '">'
      + '<rect width="100" height="100" fill="#000"/><circle cx="47" cy="52" r="45" fill="#fff"/>'
      + '<circle cx="60" cy="45" r="43" fill="#000"/></mask></defs>'
      + '<rect width="100" height="100" fill="#FAFAFA" mask="url(#es2m' + innerBoard._i + ')"/></svg>'
      + '<span>' + txt + '</span>';
    return d;
  }
  (function build(){
    coverEl.style.zIndex = '50'; // geschlossen: Deckel zuoberst
    document.getElementById('bkCoverFront').appendChild(mkImg(COVER_FRONT.f, COVER_FRONT.alt, true, 148, 210));
    document.getElementById('bkCoverIn').appendChild(mkImg(COVER_FRONT.f, '', false, 148, 210)); // Wrap innen (gespiegelt via CSS)
    document.getElementById('bkBackTex').appendChild(mkImg(COVER_BACK.f, COVER_BACK.alt, false, 148, 210));
    // Ruecken + Rueckdeckel-Innenseite zeigen das durchlaufende Cover-Design (Wrap)
    var spineEl = document.querySelector('.bk-spine');
    spineEl.insertBefore(mkImg(COVER_BACK.f, '', false, 148, 210), spineEl.firstChild);
    document.querySelector('.bb-in').appendChild(mkImg(COVER_BACK.f, '', false, 148, 210));
    document.getElementById('bkHinge').appendChild(mkImg(COVER_BACK.f, '', false, 148, 210));
    function faceEl(cls, content){
      var pf = document.createElement('div'); pf.className = 'pf ' + cls;
      pf.appendChild(content);
      var c = document.createElement('div'); c.className = 'curl'; pf.appendChild(c);
      var sh = document.createElement('div'); sh.className = 'sheen'; pf.appendChild(sh);
      return pf;
    }
    for(var i = 0; i < LEAVES; i++){
      var leaf = document.createElement('div'); leaf.className = 'bk-leaf';
      var pl = document.createElement('div'); pl.className = 'pl';
      pl.appendChild(faceEl('front', mkImg(PAGES[2*i].f, PAGES[2*i].alt, i < 2, 148, 210)));
      pl.appendChild(faceEl('back', PAGES[2*i+1]
        ? mkImg(PAGES[2*i+1].f, PAGES[2*i+1].alt, i < 2, 148, 210)
        : innerBoard('ECLIPSE STUDIOS*<br>HAMBURG')));
      leaf.appendChild(pl);
      leaf.style.zIndex = String(40 - i);   // rechter Stapel: oberstes Blatt oben
      book.insertBefore(leaf, coverEl);
      leafEls.push(leaf);
    }
    strip.appendChild(mkImg(COVER_FRONT.f, COVER_FRONT.alt, false, 148, 210));
    PAGES_ALL.forEach(function(s){ strip.appendChild(mkImg(s.f, s.alt, false, 148, 210)); });
  })();
  /* Blockdicke proportional zur Blattzahl + Blatt-Z-Positionen (px, resize-fest) */
  var zClosed = [], zOpen = [], btzClosed = 10;
  var edgeRClipO = 'inset(0% 0% 0% 0%)', edgeTClipO = 'inset(0% 0% 0% 0%)';
  function sizeBook(){
    var pw = book.offsetWidth || 300;
    var bt = pw * (.09 + .016 * LEAVES);
    var d = Math.max(2, Math.min(2.6, (bt / 2 - 10) / Math.max(LEAVES, 1)));
    book.style.setProperty('--bt', bt + 'px');
    for(var i = 0; i < LEAVES; i++){
      zClosed[i] = bt / 2 - 3 - i * d;       // geschlossen: gestaffelt unter dem Deckel
      zOpen[i] = 3 + (LEAVES - i) * 3.2;     // offen: jedes Blatt auf EIGENER Z-Ebene, nie koplanar
    }
    btzClosed = bt / 2 - 3 - LEAVES * d - 2;
    // Tiefe direkt als GSAP-Transform (kein CSS-var im transform -> Safari-sicher)
    if(window.gsap){
      leafEls.forEach(function(el, i){ gsap.set(el.firstChild, { z:zClosed[i] }); });
      gsap.set(blocktopEl, { z:btzClosed });
    }
    var eF = Math.max(0, (bt / 2 - 26) / bt * 100).toFixed(2);
    edgeRClipO = 'inset(0% ' + eF + '% 0% 0%)';
    edgeTClipO = 'inset(' + eF + '% 0% 0% 0%)';
  }
  sizeBook();
  window.addEventListener('resize', sizeBook);

  /* ============ Motion nur mit GSAP + ohne reduced-motion ============ */
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce || !window.gsap || !window.ScrollTrigger){ return; } // Statik-Fallback bleibt aktiv
  document.documentElement.classList.remove('es2-static');
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* ---------- 1) Eclipse-Band schwarz → weiß (vektorscharf) ---------- */
  var band = document.getElementById('eclWhite');
  var circle = band.querySelector('.es2-circle');
  var glow = band.querySelector('.es2-glow');
  var lbl = band.querySelector('.es2-lbl');
  var tl1 = gsap.timeline({
    defaults:{ ease:'none' },
    scrollTrigger:{ trigger:band, start:'top top', end:'+=70%', scrub:0.5, pin:true, anticipatePin:1 }
  });
  tl1.to(lbl, { opacity:1, duration:.3 }, 0)
     .to(circle, { scale:1, duration:1.6, ease:'power2.in' }, 0)
     .addLabel('lightOn', 1.05)
     .to(lbl, { opacity:0, duration:.25 }, 1.15)
     .to(glow, { opacity:0, duration:.35 }, 1.2);
  var stW = tl1.scrollTrigger;

  /* ---------- 2) Buch: Reveal → Cover öffnet → Blätter → Schließen ---------- */
  var stage = document.getElementById('fbStage');
  var dark = document.getElementById('fbDark');
  var rlbl = document.getElementById('fbRlbl');
  var cta = document.getElementById('fbCta');
  var scene = document.getElementById('bkScene');
  var rig = document.getElementById('bkRig');
  var shift = document.getElementById('bkShift');
  var blockShade = document.getElementById('bkBlockShade');
  var specBand = document.getElementById('fbSpecBand');
  var idle = document.getElementById('bkIdle');
  var tilt = document.getElementById('bkTilt');
  var bind = document.getElementById('bkBind');
  var covOut = coverEl.querySelector('.cov-out');
  var covIn = coverEl.querySelector('.cov-in');
  var hinge = document.getElementById('bkHinge');
  var edgeR = document.querySelector('#fbDark .bk-edge-r');
  var edgeT = document.querySelector('#fbDark .bk-edge-t');
  var fFaces = [], bFaces = [];
  leafEls.forEach(function(el){
    fFaces.push(el.querySelector('.pf.front'));
    bFaces.push(el.querySelector('.pf.back'));
  });
  var N = PAGES.length;
  var turns = Math.floor((N - 1) / 2);   // letztes Blatt bleibt als rechte Seite liegen
  var K = OPEN_K;

  // Idle-Parallaxe (zeitbasiert) + Pointer-Tilt — eigene Wrapper, kollidiert nicht mit dem Scrub
  // Perf: Tweens laufen nur, wenn die Buehne sichtbar ist; 2. Rotation mobil aus
  var idleT1 = gsap.to(idle, { y:9, duration:3.2, yoyo:true, repeat:-1, ease:'sine.inOut' });
  var idleT2 = IS_M ? null : gsap.to(idle, { rotationY:2.2, rotationX:-1.1, duration:4.3, yoyo:true, repeat:-1, ease:'sine.inOut' });
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var vis = en[0].isIntersecting;
      idleT1.paused(!vis);
      if(idleT2) idleT2.paused(!vis);
    }, { threshold:0 }).observe(stage);
  }
  if(window.matchMedia('(pointer:fine)').matches){
    var qx = gsap.quickTo(tilt, 'rotationY', { duration:.7, ease:'power2.out' });
    var qy = gsap.quickTo(tilt, 'rotationX', { duration:.7, ease:'power2.out' });
    stage.addEventListener('pointermove', function(e){
      var r = stage.getBoundingClientRect();
      qx(((e.clientX - r.left) / r.width - .5) * 3.5);
      qy(-((e.clientY - r.top) / r.height - .5) * 2.5);
    });
    stage.addEventListener('pointerleave', function(){ qx(0); qy(0); });
  }

  gsap.set(rig, { rotationY:-32, rotationX:10, scale:.96 });
  // Deckkraft deterministisch: Rueckseiten & Innendeckel erst ab 90-Grad-Punkt rendern
  gsap.set(bFaces, { autoAlpha:0 });
  gsap.set(covIn, { autoAlpha:0 });
  gsap.set([edgeR, edgeT], { clipPath:'inset(0% 0% 0% 0%)' });
  gsap.set(hinge, { rotationY:-90 });

  var snapTimes = [0];
  var tl = gsap.timeline({
    defaults:{ ease:'power2.inOut' },
    scrollTrigger:{
      trigger:stage, start:'top top',
      end:function(){ return '+=' + Math.round(window.innerHeight * (2.2 + 1.8 * K + turns * 1.0)); },
      scrub:0.6, pin:true, anticipatePin:1, invalidateOnRefresh:true,
      snap:{ snapTo:snapPoints, duration:{ min:.15, max:.55 }, delay:.06, ease:'power1.inOut' }
    }
  });
  ScrollTrigger.addEventListener('refreshInit', sizeBook);

  var p = 0;
  // Reveal (Bug-2-Fix, unverändert)
  tl.to(rlbl, { opacity:1, duration:.3, ease:'none' }, 0);
  tl.to(dark, { clipPath:'circle(75% at 50% 50%)', duration:1.3, ease:'power2.in' }, 0);
  tl.addLabel('lightOff', .95);
  tl.to(rlbl, { opacity:0, duration:.22, ease:'none' }, .6); // Slogan weg, bevor das Buch frei steht
  p = 1.45;

  // Cover öffnet um den Rücken; Buch rückt um die halbe Seitenbreite nach —
  // der Rücken wandert in die Bildmitte (alles in EINER 3D-Szene)
  tl.to(rig, { rotationY:-5.5, rotationX:4, scale:1, duration:1.5 * K }, p); // Lese-Pose: leicht gekippt, Seiten bleiben buendig
  tl.to(shift, { xPercent:50, duration:1.6 * K }, p + .1 * K);
  tl.set(coverEl, { zIndex:60 }, p + .2 * K);
  tl.to(coverEl, { rotationY:-178, duration:1.7 * K, ease:'power2.inOut' }, p + .25 * K);
  tl.to(hinge, { rotationY:-268, duration:1.7 * K, ease:'power2.inOut' }, p + .25 * K); // Steg klebt am Deckel (theta - 90)
  tl.set(coverEl, { zIndex:1 }, p + 1.1 * K); // offener Deckel liegt UNTER den gelandeten Blaettern
  tl.set(covOut, { autoAlpha:0 }, p + 1.1 * K);
  tl.set(covIn, { autoAlpha:1 }, p + 1.1 * K);
  tl.to(bind, { autoAlpha:1, duration:.3, ease:'none' }, p + 1.05 * K);
  // Blaetter senken sich auf die Aufschlag-Ebene: Bund schliesst sich
  leafEls.forEach(function(el, i){
    tl.to(el.firstChild, { z:function(){ return zOpen[i]; }, duration:1.4 * K, ease:'power2.inOut' }, p + .35 * K);
  });
  tl.to(blocktopEl, { z:1, duration:1.4 * K, ease:'power2.inOut' }, p + .35 * K);
  tl.to(edgeR, { clipPath:function(){ return edgeRClipO; }, duration:1.4 * K, ease:'power2.inOut' }, p + .35 * K);
  tl.to(edgeT, { clipPath:function(){ return edgeTClipO; }, duration:1.4 * K, ease:'power2.inOut' }, p + .35 * K);
  tl.to(blockShade, { opacity:.4, duration:.5 * K, ease:'power1.in' }, p + .25 * K);
  tl.to(blockShade, { opacity:0, duration:.8 * K, ease:'power1.out' }, p + .95 * K);
  p += 2.2 * K;

  // Ansicht v: links Seite 2v, rechts Seite 2v+1 (v0 = Innendeckel | Seite 1)
  function viewDwell(v){
    var pg = PAGES[Math.min(2 * v, N - 1)];
    return (pg && pg.dwell) || DWELL;
  }
  function turnLeaf(i){
    var lf = leafEls[i];
    var fc = lf.querySelector('.pf.front .curl');
    var bc = lf.querySelector('.pf.back .curl');
    var fs = lf.querySelector('.pf.front .sheen');
    var bs = lf.querySelector('.pf.back .sheen');
    tl.set(lf, { zIndex:70 }, p);                 // fliegendes Blatt ueber allem
    tl.to(lf, { rotationY:-(177.5 + i * .6), duration:.55 }, p);
    tl.set(lf, { zIndex:20 + i }, p + .45);        // links: spaeter Umgeblaettertes liegt oben
    tl.set(fFaces[i], { autoAlpha:0 }, p + .275);  // 90-Grad-Punkt: nur noch Rueckseite rendern
    tl.set(bFaces[i], { autoAlpha:1 }, p + .275);
    if(!IS_M){
      tl.fromTo(fc, { opacity:.3 }, { opacity:.5, duration:.27, ease:'power1.in' }, p);
      tl.to(fc, { opacity:.3, duration:.25, ease:'power1.out' }, p + .28);
      tl.fromTo(bc, { opacity:.5 }, { opacity:.3, duration:.27, ease:'power1.out' }, p + .28);
      tl.fromTo(fs, { backgroundPosition:'85% 0' }, { backgroundPosition:'15% 0', duration:.55, ease:'none' }, p);
      tl.fromTo(bs, { backgroundPosition:'15% 0' }, { backgroundPosition:'85% 0', duration:.55, ease:'none' }, p);
    }
    p += .62;
  }
  for(var v = 0; v < turns; v++){
    var dw = viewDwell(v);
    tl.addLabel('v' + v, p + dw * .5);
    snapTimes.push(p + dw * .5);
    p += dw;
    turnLeaf(v);
  }
  var dwL = viewDwell(turns);
  tl.addLabel('v' + turns, p + dwL * .5);
  snapTimes.push(p + dwL * .5);
  p += dwL + .15;

  // Schließen: Riffle rückwärts (Stapel-Geometrie stimmt von selbst), Cover zu, Pose zurück
  for(var c = turns - 1; c >= 0; c--){
    var tC = p + (turns - 1 - c) * .07;
    tl.set(leafEls[c], { zIndex:70 }, tC);
    tl.to(leafEls[c], { rotationY:0, duration:.8 }, tC);
    tl.set(leafEls[c], { zIndex:40 - c }, tC + .55);
    tl.set(bFaces[c], { autoAlpha:0 }, tC + .4);
    tl.set(fFaces[c], { autoAlpha:1 }, tC + .4);
  }
  leafEls.forEach(function(el, i){
    tl.to(el.firstChild, { z:function(){ return zClosed[i]; }, duration:1.0, ease:'power2.inOut' }, p + .2);
  });
  tl.to(blocktopEl, { z:function(){ return btzClosed; }, duration:1.0, ease:'power2.inOut' }, p + .2);
  tl.to([edgeR, edgeT], { clipPath:'inset(0% 0% 0% 0%)', duration:1.0, ease:'power2.inOut' }, p + .2);
  var coverStart = p + turns * .07 + .25;
  tl.set(coverEl, { zIndex:60 }, coverStart);
  tl.to(bind, { autoAlpha:0, duration:.25, ease:'none' }, coverStart - .05);
  tl.to(coverEl, { rotationY:0, duration:1.0 }, coverStart);
  tl.to(hinge, { rotationY:-90, duration:1.0 }, coverStart);
  tl.set(covIn, { autoAlpha:0 }, coverStart + .5);
  tl.set(covOut, { autoAlpha:1 }, coverStart + .5);
  tl.to(shift, { xPercent:0, duration:1.0 }, coverStart - .1);
  tl.to(rig, { rotationY:-26, rotationX:8, scale:.985, duration:1.15 }, coverStart - .1);
  p = coverStart + 1.15;
  // Bestandsfehler (Session 26, E1): der CTA stand auf opacity:0 ohne pointer-events:none, der
  // unsichtbare Button war also die ganze Timeline lang klickbar UND per Tab erreichbar. Bis
  // Session 25 hat das eine CSS-Klasse abgefangen, die book-swipe.js gesetzt hat; mit dessen
  // Wegfall haengt es wieder an der Timeline selbst. set() ist bei scrub reversibel, der Button
  // wird also beim Zurueckscrollen genauso wieder inert.
  tl.set(cta, { pointerEvents:'none' }, 0);
  tl.fromTo(cta, { opacity:0, y:14 }, { opacity:1, y:0, duration:.45, ease:'none' }, p);
  tl.set(cta, { pointerEvents:'auto' }, p + .45);
  p += .6;
  tl.to({}, { duration:.3 }, p); // Ausklang-Puffer
  snapTimes.push(tl.duration());

  // Specular-Highlight wandert über die gesamte Strecke (eine Lichtrichtung) — mobil aus (Blend-Mode = teuer)
  if(!IS_M){
    gsap.set(specBand, { skewX:-14, xPercent:-190 });
    tl.to(specBand, { xPercent:560, duration:tl.duration(), ease:'none' }, 0);
  }

  function snapPoints(value){
    var best = snapTimes[0] / tl.duration(), dBest = 1e9;
    for(var i = 0; i < snapTimes.length; i++){
      var pt = snapTimes[i] / tl.duration();
      var d = Math.abs(pt - value);
      if(d < dBest){ dBest = d; best = pt; }
    }
    return best;
  }
  var stB = tl.scrollTrigger;
  // Skip-Ziel: schwarze Buehne mit schwebendem Buch (nach dem Reveal, vor dem Oeffnen)
  window.ES2BOOK = function(){ return stB.start + (1.5 / tl.duration()) * (stB.end - stB.start); };
  // "Scroll to Open": einmalig zeigen, nach 3s ausblenden
  var openHint = document.getElementById('fbOpenHint'), hintShown = false;
    /* Sprint: alle Styling-Book-Links springen instant zum Buch */
  Array.prototype.forEach.call(document.querySelectorAll('a[href="#book"], a[href$="#book"]'), function(a){
    if(a.classList.contains('js-skip-book')) return;
    a.addEventListener('click', function(e){
      if(window.ES2BOOK){
        e.preventDefault();
        var y = window.ES2BOOK();
        try{ window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
        catch(err){ window.scrollTo(0, y); }
        if(window.ES2HINT) window.ES2HINT();
      }
    });
  });
  if(location.hash === '#book'){
    requestAnimationFrame(function(){
      if(window.ES2BOOK){
        var y = window.ES2BOOK();
        try{ window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
        catch(err){ window.scrollTo(0, y); }
        if(window.ES2HINT) window.ES2HINT();
      }
    });
  }
  window.ES2HINT = function(){
    if(hintShown || !openHint) return;
    hintShown = true;
    openHint.classList.add('on');
    setTimeout(function(){ openHint.classList.remove('on'); }, 3000);
  };
  ScrollTrigger.create({ trigger:stage, start:'top center', once:true, onEnter:function(){ window.ES2HINT(); } });

  /* ---------- 3) Header-Logo-Crossfade synchron zum Farbwechsel ---------- */
  var lightStart = 0, lightEnd = 0;
  function calcZones(){
    lightStart = stW.labelToScroll('lightOn');
    lightEnd = stB.labelToScroll('lightOff');
  }
  function headerUpdate(){
    var y = window.scrollY || window.pageYOffset;
    document.body.classList.toggle('es2-light', y >= lightStart && y < lightEnd);
  }
  ScrollTrigger.addEventListener('refresh', function(){ calcZones(); headerUpdate(); });
  ScrollTrigger.refresh();
  window.addEventListener('scroll', headerUpdate, { passive:true });

  /* ---------- 4) Tastatur: ← → ↑ ↓ blättern (Snap-Punkte anfahren) ---------- */
  document.addEventListener('keydown', function(e){
    if(!stB.isActive) return;
    var dir = 0;
    if(e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
    else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
    if(!dir) return;
    e.preventDefault();
    var cur = stB.progress, target = null;
    if(dir > 0){
      for(var i = 0; i < snapTimes.length; i++){
        var pt = snapTimes[i] / tl.duration();
        if(pt > cur + .01){ target = pt; break; }
      }
    } else {
      for(var j = snapTimes.length - 1; j >= 0; j--){
        var pt2 = snapTimes[j] / tl.duration();
        if(pt2 < cur - .01){ target = pt2; break; }
      }
    }
    if(target === null) return;
    gsap.to(window, {
      scrollTo: stB.start + target * (stB.end - stB.start),
      duration:.6, ease:'power2.out', overwrite:true
    });
  });
})();

;

(function(){
  'use strict';
  /* ===== COMMERCE-KONFIG: Klaviyo-IDs eintragen -> Formulare werden live (sonst Demo-Modus) ===== */
  var KLAVIYO = {
    company: 'XCw9Ki',       // Public API Key. Per Design oeffentlich, gehoert ins Frontend.
    newsletter: 'XLtZmW',    // Liste "Popup Signup - Styling Book", Double-Opt-in
    waitlist: 'Vm35eQ'       // Liste "Waitlist - Back in Stock", Double-Opt-in
  };
  function subscribe(listId, email, source, props){
    if(!KLAVIYO.company || !listId){ return Promise.resolve('demo'); }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO.company), {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'revision':'2024-10-15' },
      body:JSON.stringify({ data:{ type:'subscription', attributes:{ custom_source:source,
        profile:{ data:{ type:'profile', attributes:{ email:email, properties:props || {} } } } },
        relationships:{ list:{ data:{ type:'list', id:listId } } } } })
    }).then(function(r){ if(!r.ok && r.status !== 202) throw 0; return 'ok'; });
  }
  function okMail(v){ return /.+@.+\..+/.test(v); }

  // Warteliste auf Sold-out-Karten (Klaviyo Back-in-Stock-Liste)
  Array.prototype.forEach.call(document.querySelectorAll('.wl-btn'), function(btn){
    btn.addEventListener('click', function(){
      var fm = btn.parentElement.querySelector('.wl-form');
      fm.hidden = !fm.hidden;
      if(!fm.hidden) fm.querySelector('input').focus();
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('.wl-form'), function(fm){
    fm.addEventListener('submit', function(e){
      e.preventDefault();
      var inp = fm.querySelector('input'), msg = fm.querySelector('em');
      if(!okMail(inp.value)){ msg.textContent = 'Please enter a valid email.'; return; }
      subscribe(KLAVIYO.waitlist, inp.value, 'Warteliste ' + (fm.getAttribute('data-product') || ''), { Warteliste: fm.getAttribute('data-product') || '' })
        .then(function(mode){
          fm.querySelector('button').disabled = true; inp.disabled = true;
          msg.textContent = mode === 'demo' ? '✓ Reserved (demo — add Klaviyo IDs)' : '✓ You will be notified.';
        })['catch'](function(){ msg.textContent = 'Please try again later.'; });
    });
  });
  // Newsletter im Footer
  var nlBtn = document.getElementById('nlBtn'), nlMail = document.getElementById('nlMail'), nlMsg = document.getElementById('nlMsg');
  if(nlBtn){
    nlBtn.addEventListener('click', function(){
      if(!okMail(nlMail.value)){ nlMsg.textContent = 'Please enter a valid email.'; return; }
      subscribe(KLAVIYO.newsletter, nlMail.value, 'Footer Newsletter', {})
        .then(function(mode){
          nlBtn.disabled = true; nlMail.disabled = true;
          nlMsg.textContent = mode === 'demo' ? '✓ Signed up (demo — add Klaviyo IDs)' : '✓ Welcome — drops & restocks land in your inbox.';
        })['catch'](function(){ nlMsg.textContent = 'Please try again later.'; });
    });
  }
  /* ===== HERO-SLIDESHOW: Medien aus assets/hero-media/ hinter Disc + Logo ===== */
  var HERO = {
    interval: 2000,          // ms pro Bild (endloser Loop)
    random: true,            // Zufallsreihenfolge
    dir: ES2A,
    files: ['hero-01','hero-02','hero-03','hero-04','hero-05','hero-06','hero-07','hero-08',
            'hero-09','hero-10','hero-11','hero-12','hero-13','hero-14','hero-15','hero-16'],
    video: 'hero-video'      // Session 12: Video zusaetzlich als Slide in der rechten Slideshow
  };
  (function(){
    var wrap = document.getElementById('heroMedia');
    if(!wrap) return;
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var EXT = ['webp','jpg','png'];
    var items = HERO.files.map(function(fl){ return { t:'img', f:fl }; });
    if(HERO.video) items.push({ t:'vid', f:HERO.video });
    if(HERO.random && !reduce){
      for(var i = items.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
    }
    function slot(){ var d = document.createElement('div'); d.className = 'hm-slot'; wrap.appendChild(d); return d; }
    var A = slot(), B = slot(), cur = A, nxt = B, idx = 0, timer = null, inView = true, busy = false, hold = 0;
    var vid = document.createElement('video');
    vid.muted = true; vid.setAttribute('muted', ''); vid.playsInline = true; vid.setAttribute('playsinline', '');
    vid.preload = 'metadata'; vid.loop = true;
    var Q = window.matchMedia('(max-width:768px)').matches ? '?width=760' : '';
    function tryExt(im, base, k, cb){
      if(k >= EXT.length){ cb(false); return; }
      im.onerror = function(){ tryExt(im, base, k + 1, cb); };
      im.onload = function(){ cb(true); };
      im.src = HERO.dir + base + '.' + EXT[k] + Q;
    }
    function fill(el, item, cb){
      el.innerHTML = '';
      if(item.t === 'vid'){
        if(!vid.getAttribute('data-init')){
          vid.setAttribute('data-init', '1');
          vid.poster = HERO.dir + 'video-poster.webp';
          vid.src = HERO.dir + item.f + '.mp4';
          vid.onerror = function(){ vid.onerror = null; vid.src = HERO.dir + item.f + '.mov'; };
        }
        el.appendChild(vid);
        try{ vid.currentTime = 0; var pr = vid.play(); if(pr && pr['catch']) pr['catch'](function(){}); }catch(e){}
        cb();
      } else {
        var im = document.createElement('img'); im.alt = ''; im.decoding = 'async';
        el.appendChild(im);
        tryExt(im, item.f, 0, function(){ cb(); });
      }
    }
    function step(){
      if(busy) return;
      if(hold > 0){ hold--; return; }   /* Video-Slide laeuft laenger als ein Bild */
      busy = true;
      idx = (idx + 1) % items.length;
      fill(nxt, items[idx], function(){
        nxt.classList.add('on'); cur.classList.remove('on');
        if(cur.firstChild === vid){ try{ vid.pause(); }catch(e){} }
        var t = cur; cur = nxt; nxt = t;
        hold = items[idx].t === 'vid' ? 2 : 0;
        busy = false;
      });
    }
    fill(cur, items[0], function(){ cur.classList.add('on'); if(items[0].t === 'vid') hold = 2; });
    var spv = document.getElementById('spVideo');
    if(spv){
      // Fallback: wenn das Video nicht laedt -> Standbild
      spv.addEventListener('error', function(){
        var im = document.createElement('img');
        im.src = ES2A + 'video-poster.webp'; im.alt = '';
        im.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover';
        spv.parentElement.insertBefore(im, spv); spv.remove(); spv = null;
      });
    }
    if(reduce){
      if(spv){ spv.removeAttribute('autoplay'); try{ spv.pause(); }catch(e){} }
      return; // Standbilder statt Video/Slideshow
    }
    if(spv){
      // iOS/Android-Autoplay-Kickstart (Low-Power-Mode, Data-Saver)
      var kick = function(){ if(!spv) return; var p = spv.play(); if(p && p['catch']) p['catch'](function(){}); };
      spv.addEventListener('loadeddata', kick);
      window.addEventListener('touchstart', kick, { once:true, passive:true });
      document.addEventListener('visibilitychange', function(){ if(!document.hidden) kick(); });
    }
    timer = setInterval(function(){ if(inView && !document.hidden) step(); }, HERO.interval);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        inView = en[0].isIntersecting;
        if(spv){
          if(inView){ var p2 = spv.play(); if(p2 && p2['catch']) p2['catch'](function(){}); }
          else spv.pause();
        }
      }, { threshold:0 }).observe(wrap);
    }
  })();

  // Skip zur Buch-Buehne: Klick ueberspringt die Scroll-Animation (Fallback: normaler Anker)
  Array.prototype.forEach.call(document.querySelectorAll('.js-skip-book, .es2-sticky .pri'), function(a){
    a.addEventListener('click', function(e){
      if(window.ES2BOOK){
        e.preventDefault();
        var y = window.ES2BOOK();
        try{ window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
        catch(err){ window.scrollTo(0, y); }
        if(window.ES2HINT) window.ES2HINT();
      }
    });
  });

  // Font-Test-Umschalter (Session 31, Fix 2): ersatzlos entfernt. Der Handler hat #fontSwitch
  // bedient, body[data-font] gesetzt und die Wahl unter localStorage['es2font'] gemerkt.
  // Markup (sections/hero-split.liquid), CSS (assets/theme.css) und dieser Handler sind weg;
  // die Schrift steht jetzt fest im :root von assets/theme.css. Ein bei Testern evtl. noch
  // liegender es2font-Eintrag wird nirgends mehr gelesen und bleibt damit wirkungslos.

  // Hamburger-Nav (mobil) — robustes State-Management:
  // eine einzige Quelle der Wahrheit (setNav), ARIA immer synchron, Escape schliesst,
  // idempotente Bindung (kein Doppel-Listener, falls Script je zweimal laeuft)
  var nb = document.getElementById('navBurger');
  if(nb && !nb.hasAttribute('data-nav-init')){
    nb.setAttribute('data-nav-init', '1');
    var setNav = function(on){
      document.body.classList.toggle('nav-open', on);
      nb.setAttribute('aria-expanded', on ? 'true' : 'false');
    };
    nb.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      setNav(!document.body.classList.contains('nav-open'));
    });
    Array.prototype.forEach.call(document.querySelectorAll('.nav-sheet a'), function(a){
      a.addEventListener('click', function(){ setNav(false); });
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && document.body.classList.contains('nav-open')) setNav(false);
    });
  }

  // Sticky Mobile-CTA: kaufen ohne durch die Animation zu scrollen
  var bar = document.getElementById('es2Sticky');
  if(bar){
    var upd = function(){ bar.classList.toggle('on', (window.scrollY || window.pageYOffset || 0) > window.innerHeight * .6); };
    window.addEventListener('scroll', upd, { passive:true });
    upd();
  }
})();
